webpackJsonp([1],{

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(60)

var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(117),
  /* scopeId */
  "data-v-03256728",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(119),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 117:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dropzone-area",
    attrs: {
      "drag-over": "handleDragOver"
    }
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropzone-text"
  }, [_c('span', {
    staticClass: "dropzone-title"
  }, [_vm._v("Drop Sketch 43 file here or click to select")])])
}]}

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      width: "" + (_vm.imageWidth + 60) + "px",
      height: "" + _vm.imageHeight + "px",
      margin: "30px 50px"
    })
  }, [(_vm.imageData) ? _c('div', {
    style: ({
      position: "relative",
      backgroundImage: "url(" + _vm.imageData + ")",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
      backgroundPosition: "center",
      backgroundSize: "" + _vm.imageWidth + "px " + _vm.imageHeight + "px",
      width: "" + _vm.imageWidth + "px",
      height: "" + _vm.imageHeight + "px"
    })
  }, _vm._l((_vm.artboards), function(artboard, key, index) {
    return _c('div', {
      style: ({
        color: "white",
        position: "absolute",
        left: "" + (key * (_vm.PREVIEW_ARTBOARD_PADDING + _vm.artboardWidth)) + "px",
        top: "" + (artboard.frame.y * _vm.artboardFactor) + "px",
        width: "" + _vm.artboardWidth + "px",
        height: "" + (artboard.frame.height * _vm.artboardFactor) + "px",
        boxSizing: "border-box"
      })
    }, _vm._l((artboard.layers), function(child) {
      return _c('layer', {
        key: child.do_objectID,
        attrs: {
          "layer": child,
          "artboard-width": _vm.artboardWidth,
          "artboard-factor": (_vm.artboardWidth / artboard.frame.width)
        }
      })
    }))
  })) : _vm._e(), _vm._v(" "), (!_vm.imageData) ? _c('div', [_c('dropzone', {
    on: {
      "changed": _vm.onFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "color": "red"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.error) + "\n    "), (_vm.error) ? _c('div', [_vm._v("\n      You can download Sketch 43 Beta here: "), _c('a', {
    attrs: {
      "href": "https://rink.hockeyapp.net/api/2/apps/0172d48cceec171249a8d850fb16276b?format=zip"
    }
  }, [_vm._v("Download")])]) : _vm._e()]), _vm._v(" "), _vm._m(0)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/AnimaApp/sketch-web-viewer/raw/master/Fitness%20App.sketch"
    }
  }, [_vm._v("\n      Demo file\n    ")])])
}]}

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:top",
      value: (_vm.layer.name + ', \ntop: ' + _vm.layer.frame.y + ', left: ' + _vm.layer.frame.x + ', width: ' + _vm.layer.frame.width + ', height: ' + _vm.layer.frame.height),
      expression: "layer.name  +', \\ntop: ' + layer.frame.y + ', left: ' + layer.frame.x + ', width: ' + layer.frame.width + ', height: ' + layer.frame.height",
      arg: "top"
    }],
    staticClass: "layer",
    style: ({
      position: "absolute",
      left: "" + (_vm.layer.frame.x * _vm.artboardFactor) + "px",
      top: "" + (_vm.layer.frame.y * _vm.artboardFactor) + "px",
      width: "" + (_vm.layer.frame.width * _vm.artboardFactor) + "px",
      height: "" + (_vm.layer.frame.height * _vm.artboardFactor) + "px",
      visibility: "" + (_vm.layer.isVisible ? "visibile" : "hidden"),
      boxSizing: "border-box"
    }),
    attrs: {
      "data-name": _vm.layer.name,
      "data-id": _vm.layer.do_objectID
    }
  }, _vm._l((_vm.layer.layers), function(child) {
    return (_vm.layer.isVisible) ? _c('layer', {
      key: _vm.layer.do_objectID,
      attrs: {
        "layer": child,
        "artboard-width": _vm.artboardWidth,
        "artboard-factor": _vm.artboardFactor
      }
    }) : _vm._e()
  }))
},staticRenderFns: []}

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(61)
__webpack_require__(62)

var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(118),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PREVIEW_MAX_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PREVIEW_ARTBOARD_PADDING; });
var PREVIEW_MAX_SIZE = 2048.0;
var PREVIEW_ARTBOARD_PADDING = 60.0;

/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('tooltip', function (el, binding) {
  $(el).attr('data-toggle', 'tooltip').attr('data-title', binding.value).attr('data-placement', binding.arg).tooltip();
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dropzone__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Layer__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const__ = __webpack_require__(54);






var JSZip = __webpack_require__(68);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Layer: __WEBPACK_IMPORTED_MODULE_1__components_Layer___default.a,
    Dropzone: __WEBPACK_IMPORTED_MODULE_0__components_Dropzone___default.a
  },

  props: ['help'],

  data: function data() {
    return {
      imageData: undefined,
      imageWidth: undefined,
      imageHeight: undefined,
      artboardWidth: 0,
      artboardFactor: 0,
      artboards: undefined,
      error: undefined,
      PREVIEW_ARTBOARD_PADDING: __WEBPACK_IMPORTED_MODULE_2__const__["a" /* PREVIEW_ARTBOARD_PADDING */],
      PREVIEW_MAX_SIZE: __WEBPACK_IMPORTED_MODULE_2__const__["b" /* PREVIEW_MAX_SIZE */]
    };
  },


  methods: {
    onFileChange: function onFileChange(file) {
      var vm = this;
      var reader = new FileReader();

      reader.onload = function (e) {
        var data = e.target.result;
        JSZip.loadAsync(data).then(function (zip) {
          zip.forEach(function (relativePath, zipEntry) {
            if (relativePath === 'previews/preview.png') {
              zipEntry.async('base64').then(function success(content) {
                vm.imageData = 'data:image/png;base64,' + content;

                var image = new Image();

                image.onload = function () {
                  vm.imageWidth = image.width;
                  vm.imageHeight = image.height;

                  if (vm.imageWidth && vm.artboards && vm.imageWidth >= __WEBPACK_IMPORTED_MODULE_2__const__["b" /* PREVIEW_MAX_SIZE */]) {
                    vm.artboardWidth = (__WEBPACK_IMPORTED_MODULE_2__const__["b" /* PREVIEW_MAX_SIZE */] - __WEBPACK_IMPORTED_MODULE_2__const__["a" /* PREVIEW_ARTBOARD_PADDING */] * (vm.artboards.length - 1)) / vm.artboards.length;
                  }
                };

                image.src = vm.imageData;
              }, function error(e) {
                console.log(e);
                vm.error = 'Could not load Sketch preview';
              });
            } else if (relativePath.startsWith('pages/')) {
              zipEntry.async('string').then(function success(content) {
                var page = JSON.parse(content);
                vm.artboards = page.layers;

                if (vm.imageWidth && vm.artboards && vm.imageWidth >= __WEBPACK_IMPORTED_MODULE_2__const__["b" /* PREVIEW_MAX_SIZE */]) {
                  vm.artboardWidth = (__WEBPACK_IMPORTED_MODULE_2__const__["b" /* PREVIEW_MAX_SIZE */] - __WEBPACK_IMPORTED_MODULE_2__const__["a" /* PREVIEW_ARTBOARD_PADDING */] * (vm.artboards.length - 1)) / vm.artboards.length;
                }
              }, function error(e) {
                console.log(e);
                vm.error = 'Could not load page';
              });
            }
          });
        }, function (e) {
          console.log(e);
          vm.error = 'Only .sketch files that were saved using the new Sketch 43 are supported.';
        });
      };
      reader.readAsArrayBuffer(file);
    }
  }
});

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  methods: {
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var file = files[0];
      this.$emit('changed', file);
    }
  }

});

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'layer',
  props: ['layer', 'artboardWidth', 'artboardFactor']
});

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 61:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 62:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[55]);


// WEBPACK FOOTER //
// static/js/app.e069298035b0aacb7fe7.js